module.exports = __webpack_public_path__ + "img/card-compare-product.0e7668db.png";